import * as React from 'react'
import { connect } from 'react-redux'


class QuoteNumber extends React.Component<any, any>{

    render(){
        return (
            <div className="col-12 quote-number" style={{ marginTop:'-14px' }}>
                <strong><p>Quote number { this.props.quoteNumber }</p></strong>
            </div> 
        )
    }

}


const mapStateToProps = state => ({
    quoteNumber: state.fields.quoteNumber
})


export default connect( mapStateToProps, null )(QuoteNumber)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/quote-number.tsx